import { Language } from '@configs/language';

const BASE_LANGUAGE_LABELS = {
  afnTitle: 'Add funds',
  afnSelectorTitle: 'In which currency would you like to add funds?',
  afnInstructionsTitle:
    'Use these instructions funds to your EFEX account from any external bank account.',
  afnSwiftCodeTitle: 'If you want to receive an international payment, add:',
  afnSwiftCode: 'SWIFT Code',
  afnTransferMethod: 'Transfer method',
  afnClabe: 'CLABE',
  afnIban: 'IBAN',
  afnBeneficiary: 'Beneficiary',
  afnBeneficiaryAddress: 'Beneficiary address',
  afnBeneficiaryBank: 'Beneficiary bank',
  afnBankAddress: 'Bank address',
  afnCurrency: 'Currency',
  afnAccountNumber: 'Account number',
  afnAccountType: 'Account type',
  afnAchRoutingNumber: 'ACH (Routing Number)',
  afnWireRoutingNumber: 'Wire (Routing Number)',
  afnTransitNumber: 'Transit Number',
  afnInstitutionNumber: 'Institution Number',
  afnDisclaimer1:
    "WIRE: It may take between 1 to 3 hours for the funds to be credited (depending on the FED's bank cuts).",
  afnDisclaimer2: 'ACH: May take 1 to 2 days for funds to be credited.',
  afnCopiedToClipboard: '{{name}} has been copied to the clipboard',
  afnGlobalAccount: 'Global accounts',
  afnLoanAccount: 'Accounts linked to a loan',
  afnWalletTooltip:
    'This amount is part of the guarantee established by {{businessName}} and will be temporarily locked. Your account linked to a loan allows you to securely collect funds to repay credit lines or factoring. This activity is regulated in the U.S. under applicable financial regulations. If you have any questions, the {{businessName}} team will be happy to assist you.',
  afnGlobalAccountTooltip:
    'The amount added to these global accounts can be used normally for your transfers, conversions, bulk payments, and more.',
  afnLoanAccountTooltip:
    'The amount added to these accounts will be temporarily locked. This account is part of the guarantee established by {{businessName}}. Your account linked to loan allow you to securely collect funds to repay credit lines or factoring.',
  afnWalletAlert:
    'The amount added to this guarantee account will be temporarily locked.',
  afnInternationalPaymentInfo:
    'Important: This bank does not accept international transfers directly. For SWIFT payments, your bank must send the funds to the intermediary bank indicated below.',
  afnIntermediaryBankSwiftCode: 'Intermediary bank SWIFT Code',
  afnIntermediaryBankName: 'Intermediary bank',
  afnIntermediaryBankAddress: 'Intermediary bank address',
};

type LabelsLanguage = keyof typeof BASE_LANGUAGE_LABELS;

const ADD_FUNDS_NEW_LABELS: Record<Language, Record<LabelsLanguage, string>> = {
  EN: BASE_LANGUAGE_LABELS,
  ES: {
    afnTitle: 'Añadir fondos',
    afnSelectorTitle: '¿En qué moneda te gustaría añadir fondos?',
    afnInstructionsTitle:
      'Usa estas instrucciones para añadir fondos a tu cuenta de EFEX desde cualquier cuenta bancaria externa.',
    afnSwiftCodeTitle: 'Si deseas recibir un pago internacional, añade:',
    afnSwiftCode: 'Código SWIFT',
    afnTransferMethod: 'Método de transferencia',
    afnClabe: 'CLABE',
    afnIban: 'IBAN',
    afnBeneficiary: 'Beneficiario',
    afnBeneficiaryAddress: 'Dirección del beneficiario',
    afnBeneficiaryBank: 'Banco del beneficiario',
    afnBankAddress: 'Dirección del banco',
    afnCurrency: 'Moneda',
    afnAccountNumber: 'Número de cuenta',
    afnAccountType: 'Tipo de cuenta',
    afnAchRoutingNumber: 'ACH (Routing Number)',
    afnWireRoutingNumber: 'Wire (Routing Number)',
    afnTransitNumber: 'Transit Number',
    afnInstitutionNumber: 'Institution Number',
    afnDisclaimer1:
      'WIRE: Pueden tardar entre 1 a 3 horas en verse acreditados los fondos (Depende de los cortes bancarios de la FED).',
    afnDisclaimer2:
      'ACH: Pueden tardar entre 1 a 2 días en verse acreditados los fondos.',
    afnCopiedToClipboard: '{{name}} se ha copiado al portapapeles',
    afnGlobalAccount: 'Cuentas globales',
    afnLoanAccount: 'Cuentas asociadas a préstamo',
    afnWalletTooltip:
      'Este monto es parte de la garantía establecida por {{businessName}} y estará bloqueado temporalmente. Tus cuentas con garantía te dan la posibilidad de recaudar fondos de manera segura para repagar líneas de crédito o factoraje. Esta actividad está regulada en los EE. UU. conforme a las normativas financieras aplicables. Si tienes alguna duda, el equipo de {{businessName}} estará encantado de ayudarte.',
    afnGlobalAccountTooltip:
      'El monto añadido a estas cuentas globales lo puedes usar con normalidad para tus transferencias, conversiones, pagos masivos y más.',
    afnLoanAccountTooltip:
      'El monto añadido a estas cuentas estará bloqueado temporalmente. Esta cuenta es parte de la garantía establecida por {{businessName}}. Tus cuentas asociadas a préstamos te dan la posibilidad de recaudar fondos de manera segura para repagar líneas de crédito o factoraje.',
    afnWalletAlert:
      'El monto añadido a esta cuenta asociada a préstamo estará bloqueado temporalmente.',
    afnInternationalPaymentInfo:
      'Importante: Este banco no acepta transferencias internacionales directamente. Para pagos SWIFT, tu banco debe enviar los fondos al banco intermediario indicado a continuación.',
    afnIntermediaryBankSwiftCode: 'Código SWIFT del banco intermediario',
    afnIntermediaryBankName: 'Banco intermediario',
    afnIntermediaryBankAddress: 'Dirección del banco intermediario',
  },
};

export default ADD_FUNDS_NEW_LABELS;
